export default {
  NO_GROUP_SEARCH_TOWNS: 'validation.errors.groupSearch.noResultsForTownCity',
  GET_TOWNS_FAILED: 'validation.errors.groupSearch.failedGetTowns',
  POSTCODE_FORMAT_ERROR: 'validation.errors.postcode.formatError',
  FIELD_REQUIRED: 'validation.errors.groupSearch.searchTypeUnknown',
};
